import { useEffect } from 'react';

export const MetricsYandex = () => {
  useEffect(() => {
    (function (m, e, t, r, i, k, a) {
      // @ts-ignore
      m[i] =
        // @ts-ignore

        m[i] ||
        function () {
          // @ts-ignore
          // eslint-disable-next-line prefer-rest-params
          (m[i].a = m[i].a || []).push(arguments);
        };

      // @ts-ignore
      m[i].l = 1 * new Date();
      for (let j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) {
          return;
        }
      }
      // @ts-ignore
      k = e.createElement(t);
      // @ts-ignore
      a = e.getElementsByTagName(t)[0];
      // @ts-ignore
      k.async = 1;
      // @ts-ignore
      k.src = r;
      // @ts-ignore
      a.parentNode.insertBefore(k, a);
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

    // @ts-ignore
    window.ym(102097821, 'init', {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
    });
  }, []);

  return (
    <noscript>
      <div>
        <img
          src="https://mc.yandex.ru/watch/102097821"
          style={{ position: 'absolute', left: '-9999px' }}
          alt=""
        />
      </div>
    </noscript>
  );
};
